import {Component, Input, OnInit} from '@angular/core';
import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';
import {StaticDataService} from 'src/app/services/static-data.service';
import {EnterpriseService} from 'src/app/services/enterprise.service';
import {OfficeLocationsService} from 'src/app/modules/configuration/office-locations/office-locations.service';
import {Globals} from 'src/app/globals';
import {DoctorsService} from 'src/app/services/doctors.service';
import {ReportAgingFilterModel} from '../../models/ReportAgingFilterModel.model';
import {MatRadioChange} from '@angular/material/radio';
import {ErrorStateMatcher, ThemePalette} from '@angular/material/core';
import {Output, EventEmitter} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {UntypedFormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import Utils from '../../Utils/utils';
import {ClientLocationDataModel} from '../../../../models/clients/client-location-data.model';
import {
  ReportBankDepositsParamsModel,
  ReportCallListParamsModel,
  ReportCollectionParamsModel,
  ReportCreditBalanceParamsModel,
  ReportCreditCardReceiptParamsModel,
  ReportDeletedAnesthesiaParamsModel,
  ReportFeeCalculationReportParamsModel,
  ReportFinancialAuditParamsModel,
  ReportLedgerTransactionParamsModel, ReportListOfAppointmentsParamsModel,
  ReportOutstandigClaimsModel,
  ReportPatientCaseReferralsParamsModel,
  ReportPatientsNeedAppointmentParamsModel,
  ReportPatientStatementParamsModel,
  ReportRecallAppointmentParamsModel,
  ReportRecallParamsModel,
  ReportReferringAnalysisModel,
  ReportReportsToBeCompletedParamsModel,
  ReportTransactionParamsModel, ReportUnappliedCreditsParamsModel, ReportVoidedTransactionParamsModel
} from '../../models/ReportPatientStatementParamsModel.model';
import {TdoClientConfigurationModel} from '../../../../models/clients/tdo-client-configuration.model';
import {DataRangesEnum} from '../../../../models/enum/Date-Ranges.enum';
import {ReportIDEnum} from '../../../../models/enum/report-ID-enum';
import {ReportFinancialFilterModel} from '../../models/ReportFinancialFilterModel.model';
import {ReportFinancialSnapshotFilterModel} from '../../models/ReportFinancialSnapshotFilterModel.model';
import { ARService } from 'src/app/modules/ar/ar.service';
import { DataARPaymentModel } from 'src/app/models/accountsReceivable/data-ar-payment.model';
import { DatePipe } from '@angular/common';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { Constants } from 'src/app/constants';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { DataARPaymentListModel } from 'src/app/modules/ar/models/data-ar-payment-list.model';

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

interface OrderByOption {
  value: string;
  viewValue: string;
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  standalone: false,
  selector: 'app-report-aging-filter',
  templateUrl: './report-aging-filter.component.html',
  styleUrls: ['./report-aging-filter.component.scss']
})
export class ReportAgingFilterComponent implements OnInit {
  task: Task = {
    name: 'All Periods',
    completed: true,
    color: 'primary',
    subtasks: [
      {name: 'Current', completed: true, color: 'primary'},
      {name: '30 Days', completed: true, color: 'primary'},
      {name: '60 Days', completed: true, color: 'primary'},
      {name: '90+ Days', completed: true, color: 'primary'},
    ],
  };


  orderByOption: OrderByOption[] = [
    {value: '00000001-1000-0000-0000-100000000001', viewValue: 'Description'},
    {value: '00000001-1000-0000-0000-100000000002', viewValue: 'Debit'},
    {value: '00000001-1000-0000-0000-100000000003', viewValue: 'Debit %'},
    {value: '00000001-1000-0000-0000-100000000004', viewValue: 'Credit'},
    {value: '00000001-1000-0000-0000-100000000005', viewValue: 'Credit %'},
  ];

  orderByOptionDaily: OrderByOption[] = [
    {value: '00000001-1000-0000-0000-100000000006', viewValue: 'Name'}
  ];

  reports: Task = {
    name: 'All',
    completed: true,
    color: 'primary',
    subtasks: [
      {name: 'Production', completed: true, color: 'primary'},
      {name: 'Receipt and adjustments', completed: true, color: 'primary'},
      {
        name: 'Activity',
        completed: true,
        color: 'primary',
        subtasks: [{name: 'Group By Doctor', completed: true, color: 'primary'}]
      },
      {
        name: 'Transactions (type)', completed: true, color: 'primary', subtasks: [
          {name: 'Check / Cash', completed: true, color: 'primary'},
          {name: 'Credit Card Activity', completed: true, color: 'primary'},
          {name: 'Debit/ATM/E-Check', completed: true, color: 'primary'},
          {name: 'Other', completed: true, color: 'primary'}]
      },
    ],
  };


  clientList: TdoClientConfigurationModel[];
  isBusy: boolean;
  isReportForProvide: boolean = false;
  isReportForPractice: boolean = true;
  selectedClient: TdoClientConfigurationModel;
  selectedProvider: any;
  isCurrentMonth: boolean = false;
  providerDataSource: DoctorDataModel[];
  doctorSelected: DoctorDataModel;
  allComplete: boolean = false;
  allLedgerReports: boolean = false;
  allLedgerTransactionReports: boolean = false;
  selectedOrderByOption: any;
  selectedSnapShotOrderBy: OrderByOption;
  showInactive: boolean = false;
  isInteractiveReport: boolean = true;
  isAsc: boolean = true;
  selectedPaymentId:  string;
  selectedPatientId: string;
  selectedLedgerId: string;
  isTrueBalance: boolean = false;
  reportAgingFilterModel: ReportAgingFilterModel;
  reportPatientStatementFilterModel: ReportPatientStatementParamsModel;
  reportTransactionFilterModel: ReportTransactionParamsModel;
  reportVoidedTransactionFilterModel: ReportVoidedTransactionParamsModel;
  reportLedgerTransactionFilterModel: ReportLedgerTransactionParamsModel;
  reportFinancialAuditFilterModel: ReportFinancialAuditParamsModel;
  reportListOfAppointmentsModel: ReportListOfAppointmentsParamsModel;
  reportFinancialSummaryFilterModel: ReportFinancialFilterModel;
  reportFinancialSnapshotFilterModel: ReportFinancialSnapshotFilterModel;
  reportCreditBalanceFilterModel: ReportCreditBalanceParamsModel;
  reportCreditCardReceiptFilterModel: ReportCreditCardReceiptParamsModel;
  reportRecallFilterModel: ReportRecallParamsModel;
  reportProceduresWithNoClaimsModel: ReportFinancialFilterModel;
  reportClaimsNotSentModel: ReportFinancialFilterModel;
  reportOutstandingClaimsModel: ReportOutstandigClaimsModel;
  reportReferringAnalysisModel: ReportReferringAnalysisModel;
  reportBankDepositsModel: ReportBankDepositsParamsModel;
  reportFeeCalculationReportModel: ReportFeeCalculationReportParamsModel;
  reportPatientsNeedAppointmentModel: ReportPatientsNeedAppointmentParamsModel;
  reportRecallAppointmentModel: ReportRecallAppointmentParamsModel;
  reportCallListModel: ReportCallListParamsModel;
  reportCollectionFilterModel: ReportCollectionParamsModel;
  reportUnappliedCreditsModel: ReportUnappliedCreditsParamsModel;
  reportDeletedAnesthesiaModel: ReportDeletedAnesthesiaParamsModel;
  reportPatientCaseReferralsModel: ReportPatientCaseReferralsParamsModel;
  reportReportsToBeCompletedModel: ReportReportsToBeCompletedParamsModel;

  checkboxTrueBalance = new UntypedFormControl(false);
  checkboxSnapShotReport = new UntypedFormControl(true);
  checkboxShowActiveDoctors = new UntypedFormControl(false);

  locationList: ClientLocationDataModel[];
  doctorPredicate: (data: DoctorDataModel) => string;

  filterDateRangesEnums: EnumValidValueItemModel[] = [];
  selectedDateRanges: EnumValidValueItemModel;
  startDate: Date;
  endDate: Date;
  statementNote: string;
  isCurrentPatient: boolean = true;

  selectedProviders: DoctorDataModel[] = [];
  selectedProvidersList: DoctorDataModel[] = [];
  selectedClientLocation: ClientLocationDataModel[] = [];
  PaymentList:   DataARPaymentListModel[] =[];
  readonly ReportIDEnum = ReportIDEnum;

  // Transaction Reports
  transactionType: string;
  enumTransactionTypeCheck: string = 'Check';
  enumTransactionTypeCreditCard: string = 'CreditCard';
  enumTransactionTypeDebit: string = 'Debit';
  enumTransactionTypeOther: string = 'Other';

  isTransactionCheck: boolean = false;
  isTransactionCreditCard: boolean = false;
  isTransactionDebit: boolean = false;
  isTransactionOther: boolean = false;

  //Outstanding Claims
  isAllClaims: boolean = false;
  isEClaims: boolean = false;
	isADAForm: boolean = false;
	over30: boolean = false;
	over60: boolean = false;
	over90: boolean = false;

  //Bank Deposits
  isCash: boolean = false;
  isCheck: boolean = false;
  isCashandCheck: boolean = true;

  //Recall Appointment Report
  isFollowUp: boolean = true;

  //Referring Analysis Report
  isAll: boolean = false;
  IncludePerDoctor: boolean = true;
  IncludePerCode: boolean = true;
  IncludeBreakDown: boolean = true;

  //Patients Need Appointment Report
  isNewOnly: boolean = false;

  //Fee Calculation Report
  isOrderedByDate: boolean = true;
  isOrderedByToothCode: boolean = false;

  // Voided Transaction Reports
  isOrderByDateCharged: boolean = true;
  // Ledger Transactions
  isReportFormatted: boolean = true;

  private radioVal: number;
  radioStatus: boolean;


  @Output() inputValue = new EventEmitter<string>();
  @Output() newItemEvent = new EventEmitter<any>();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onChecked: EventEmitter<any> = new EventEmitter<any>();


  @Input() showParametersForReport = '';
  @Input() isGeneric: boolean = false;

  userPasswordForm: any = {input: ''};
  isAllProviders: boolean = false;
  isAllLocations: boolean = false;

  constructor(public staticDataService: StaticDataService,
              public enterpriseService: EnterpriseService,
              public locService: OfficeLocationsService,
              public doctorService: DoctorsService,
              public arservice: ARService,
              private datePipe: DatePipe,
              public globals: Globals) {

    this.selectedSnapShotOrderBy = this.orderByOptionDaily[0];

  }
  providerSelected = new UntypedFormControl('valid', [Validators.required]);
  matcher = new MyErrorStateMatcher();


  async ngOnInit() {
    this.doctorPredicate = (data: DoctorDataModel) => {
      if (data.dataContact === undefined) {
        return '';
      }
      return 'Dr. ' + data.dataContact.FirstName + ' ' + data.dataContact.LastName;
    };
    this.loadServiceData();
  }

  sendFilterToParent() {
    if (this.showParametersForReport === ReportIDEnum.reportID_AgingAnalysis) {
      this.reportAgingFilterModel = new ReportAgingFilterModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportAgingFilterModel.isProvider = true;
        this.reportAgingFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportAgingFilterModel.isPractice = true;
        this.reportAgingFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportAgingFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      // check if filter is True Balance
      if (this.isTrueBalance) {
        this.reportAgingFilterModel.IsTrueBalance = true;
      } else {
        this.reportAgingFilterModel.IsTrueBalance = false;
      }
      // check periods
      if (this.allComplete) {
        this.reportAgingFilterModel.isCurrent = true;
        this.reportAgingFilterModel.is30Day = true;
        this.reportAgingFilterModel.is60Day = true;
        this.reportAgingFilterModel.is90Day = true;
      } else {
        this.reportAgingFilterModel.isCurrent = !!this.task.subtasks.filter(t => t.completed).find(x => x.name === 'Current');
        this.reportAgingFilterModel.is30Day = !!this.task.subtasks.filter(t => t.completed).find(x => x.name === '30 Days');
        this.reportAgingFilterModel.is60Day = !!this.task.subtasks.filter(t => t.completed).find(x => x.name === '60 Days');
        this.reportAgingFilterModel.is90Day = !!this.task.subtasks.filter(t => t.completed).find(x => x.name === '90+ Days');
      }
      this.newItemEvent.emit(this.reportAgingFilterModel);
    }
    // Patient Statement
    else if (this.showParametersForReport === ReportIDEnum.reportID_PatientStatement) {
      this.reportPatientStatementFilterModel = new ReportPatientStatementParamsModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportPatientStatementFilterModel.isProvider = true;
        this.reportPatientStatementFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportPatientStatementFilterModel.isPractice = true;
        this.reportPatientStatementFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportPatientStatementFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportPatientStatementFilterModel.initialDate = this.startDate;
      this.reportPatientStatementFilterModel.endDate = this.endDate;
      this.reportPatientStatementFilterModel.statementNote = this.statementNote;
      this.newItemEvent.emit(this.reportPatientStatementFilterModel);
    }
    // List of Appointments
    else if (this.showParametersForReport === ReportIDEnum.reportID_List_of_Appointments) {
      this.reportListOfAppointmentsModel = new ReportListOfAppointmentsParamsModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportListOfAppointmentsModel.isProvider = true;
        this.reportListOfAppointmentsModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportListOfAppointmentsModel.isPractice = true;
        this.reportListOfAppointmentsModel.PracticeId = this.selectedClient.TDOCID;
        this.reportListOfAppointmentsModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportListOfAppointmentsModel.initialDate = this.startDate;
      this.reportListOfAppointmentsModel.endDate = this.endDate;
      this.newItemEvent.emit(this.reportListOfAppointmentsModel);
    }
    // Transaction Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_TransactionReport) {
      this.reportTransactionFilterModel = new ReportTransactionParamsModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportTransactionFilterModel.isProvider = true;
        this.reportTransactionFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
        this.reportTransactionFilterModel.PracticeId = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID).TDOCID;
      } if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportTransactionFilterModel.isPractice = true;
        this.reportTransactionFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportTransactionFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportTransactionFilterModel.initialDate = this.startDate;
      this.reportTransactionFilterModel.endDate = this.endDate;
      this.reportTransactionFilterModel.transactionType = this.transactionType;
      this.newItemEvent.emit(this.reportTransactionFilterModel);

    }
    // Voided Transaction
    else if (this.showParametersForReport === ReportIDEnum.reportID_VoidedTransactionReport) {
      this.reportVoidedTransactionFilterModel = new ReportVoidedTransactionParamsModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportVoidedTransactionFilterModel.isProvider = true;
        this.reportVoidedTransactionFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
        //this.reportVoidedTransactionFilterModel.PracticeId = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID).TDOCID;
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportVoidedTransactionFilterModel.isPractice = true;
        this.reportVoidedTransactionFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportVoidedTransactionFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportVoidedTransactionFilterModel.initialDate = this.startDate;
      this.reportVoidedTransactionFilterModel.endDate = this.endDate;
      this.reportVoidedTransactionFilterModel.isOrderByDateCharged = this.isOrderByDateCharged;
      this.newItemEvent.emit(this.reportVoidedTransactionFilterModel);
    }
    // Ledger Transaction
    else if (this.showParametersForReport === ReportIDEnum.reportID_LedgerTransactionReport) {
      this.reportLedgerTransactionFilterModel = new ReportLedgerTransactionParamsModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportLedgerTransactionFilterModel.isProvider = true;
        this.reportLedgerTransactionFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
        this.reportLedgerTransactionFilterModel.PracticeId = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID).TDOCID;

      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportLedgerTransactionFilterModel.isPractice = true;
        this.reportLedgerTransactionFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportLedgerTransactionFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportLedgerTransactionFilterModel.initialDate = this.startDate;
      this.reportLedgerTransactionFilterModel.endDate = this.endDate;
      // check reports selected
      if (this.allLedgerReports) {
        this.reportLedgerTransactionFilterModel.showProductionReport = true;
        this.reportLedgerTransactionFilterModel.showReceiptReport = true;
        this.reportLedgerTransactionFilterModel.showActivityReport = true;
        this.reportLedgerTransactionFilterModel.showTransactionsReport = true;
      } else {
        this.reports.subtasks.filter(t => t.completed).find(x => x.name === 'Production') ? this.reportLedgerTransactionFilterModel.showProductionReport = true : this.reportLedgerTransactionFilterModel.showProductionReport = false;
        this.reports.subtasks.filter(t => t.completed).find(x => x.name === 'Receipt and adjustments') ? this.reportLedgerTransactionFilterModel.showReceiptReport = true : this.reportLedgerTransactionFilterModel.showReceiptReport = false;
        this.reports.subtasks.filter(t => t.completed).find(x => x.name === 'Activity') ? this.reportLedgerTransactionFilterModel.showActivityReport = true : this.reportLedgerTransactionFilterModel.showActivityReport = false;
        this.reports.subtasks.filter(t => t.completed).find(x => x.name === 'Transactions (type)') ? this.reportLedgerTransactionFilterModel.showTransactionsReport = true : this.reportLedgerTransactionFilterModel.showTransactionsReport = false;
      }

      // check SubReport selected
      if (this.reportLedgerTransactionFilterModel.showTransactionsReport) {
        this.reports.subtasks.find(x => x.name === 'Transactions (type)').subtasks.filter(t => t.completed).find(x => x.name === 'Check / Cash') ? this.reportLedgerTransactionFilterModel.showTransactionCash = true : this.reportLedgerTransactionFilterModel.showTransactionCash = false;
        // this.reports.subtasks.find( x => x.name === 'Transactions (type)').subtasks.filter(t => t.completed).find(x => x.name === 'Check') ? this.reportLedgerTransactionFilterModel.showTransactionCheck = true : this.reportLedgerTransactionFilterModel.showTransactionCheck = false;
        this.reports.subtasks.find(x => x.name === 'Transactions (type)').subtasks.filter(t => t.completed).find(x => x.name === 'Credit Card Activity') ? this.reportLedgerTransactionFilterModel.showTransactionCreditCard = true : this.reportLedgerTransactionFilterModel.showTransactionCreditCard = false;
        this.reports.subtasks.find(x => x.name === 'Transactions (type)').subtasks.filter(t => t.completed).find(x => x.name === 'Debit/ATM/E-Check') ? this.reportLedgerTransactionFilterModel.showTransactionDebit = true : this.reportLedgerTransactionFilterModel.showTransactionDebit = false;
        this.reports.subtasks.find(x => x.name === 'Transactions (type)').subtasks.filter(t => t.completed).find(x => x.name === 'Other') ? this.reportLedgerTransactionFilterModel.showTransactionOther = true : this.reportLedgerTransactionFilterModel.showTransactionOther = false;
      }

      if (this.reportLedgerTransactionFilterModel.showActivityReport) {
        this.reports.subtasks.find(x => x.name === 'Activity').subtasks.filter(t => t.completed).find(x => x.name === 'Group By Doctor') ? this.reportLedgerTransactionFilterModel.isActivityGroupByDoctor = true : this.reportLedgerTransactionFilterModel.isActivityGroupByDoctor = false;
      }
      this.reportLedgerTransactionFilterModel.isNewPage = this.isReportFormatted;
      this.newItemEvent.emit(this.reportLedgerTransactionFilterModel);
    }
    // Financial Audit
    else if (this.showParametersForReport === ReportIDEnum.reportID_Financial_AuditReport) {
      this.reportFinancialAuditFilterModel = new ReportFinancialAuditParamsModel();
      this.reportFinancialAuditFilterModel.initialDate = this.startDate;
      this.reportFinancialAuditFilterModel.endDate = this.endDate;
      this.reportFinancialAuditFilterModel.PracticeId = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID).TDOCID;
      this.newItemEvent.emit(this.reportFinancialAuditFilterModel);
    }
    // Financial Summary
    else if (this.showParametersForReport === ReportIDEnum.reportID_FinancialSummary) {
      this.reportFinancialSummaryFilterModel = new ReportFinancialFilterModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportFinancialSummaryFilterModel.isProvider = true;
        this.reportFinancialSummaryFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportFinancialSummaryFilterModel.isPractice = true;
        this.reportFinancialSummaryFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportFinancialSummaryFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportFinancialSummaryFilterModel.initialDate = this.startDate;
      this.reportFinancialSummaryFilterModel.endDate = this.endDate;
      this.reportFinancialSummaryFilterModel.isCurrentMonth = this.isCurrentMonth;
      this.newItemEvent.emit(this.reportFinancialSummaryFilterModel);
    }
    // Daily Snapshot
    else if (this.showParametersForReport === ReportIDEnum.reportID_DailySnapshot) {
      this.reportFinancialSnapshotFilterModel = new ReportFinancialSnapshotFilterModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportFinancialSnapshotFilterModel.isProvider = true;
        this.reportFinancialSnapshotFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportFinancialSnapshotFilterModel.isPractice = true;
        this.reportFinancialSnapshotFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportFinancialSnapshotFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportFinancialSnapshotFilterModel.initialDate = this.startDate;
      this.reportFinancialSnapshotFilterModel.endDate = this.endDate;
      this.reportFinancialSnapshotFilterModel.isAsc = this.isAsc;
      this.reportFinancialSnapshotFilterModel.showInactive = this.showInactive;
      this.reportFinancialSnapshotFilterModel.isInteractiveReport = this.isInteractiveReport;
      this.reportFinancialSnapshotFilterModel.OrderBy = this.selectedSnapShotOrderBy.value;
      this.reportFinancialSnapshotFilterModel.dateRange = 'Today';
      this.newItemEvent.emit(this.reportFinancialSnapshotFilterModel);
    }
    // Financial Snapshot
    else if (this.showParametersForReport === ReportIDEnum.reportID_FinancialSnapshotReport) {
      this.reportFinancialSnapshotFilterModel = new ReportFinancialSnapshotFilterModel();

      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportFinancialSnapshotFilterModel.isProvider = true;
        this.reportFinancialSnapshotFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportFinancialSnapshotFilterModel.isPractice = true;
        this.reportFinancialSnapshotFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportFinancialSnapshotFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportFinancialSnapshotFilterModel.initialDate = this.startDate;
      this.reportFinancialSnapshotFilterModel.endDate = this.endDate;
      this.reportFinancialSnapshotFilterModel.isAsc = this.isAsc;
      this.reportFinancialSnapshotFilterModel.showInactive = this.showInactive;
      this.reportFinancialSnapshotFilterModel.isInteractiveReport = this.isInteractiveReport;
      this.reportFinancialSnapshotFilterModel.OrderBy = this.selectedSnapShotOrderBy.value;
      this.reportFinancialSnapshotFilterModel.dateRange = this.selectedDateRanges.ItemDisplayValue;
      this.newItemEvent.emit(this.reportFinancialSnapshotFilterModel);
    }
    // Credit Balance
    else if (this.showParametersForReport === ReportIDEnum.reportID_Credit_Balance) {
      this.reportCreditBalanceFilterModel = new ReportCreditBalanceParamsModel();

      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportCreditBalanceFilterModel.isProvider = true;
        this.reportCreditBalanceFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportCreditBalanceFilterModel.isPractice = true;
        this.reportCreditBalanceFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportCreditBalanceFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportCreditBalanceFilterModel.isAllProviders = this.isAllProviders;
      this.reportCreditBalanceFilterModel.isAllLocations = this.isAllLocations;
      this.newItemEvent.emit(this.reportCreditBalanceFilterModel);
    }
    // Credit Card Receipt
    else if (this.showParametersForReport === ReportIDEnum.reportID_CreditCardReceiptReport) {
      this.reportCreditCardReceiptFilterModel = undefined;
      if (!this.selectedPaymentId) {
        return;
      }
      this.reportCreditCardReceiptFilterModel = new ReportCreditCardReceiptParamsModel();
      // check filter for Credit Card Receipt
      this.reportCreditCardReceiptFilterModel.PaymentId = this.selectedPaymentId;
      this.reportCreditCardReceiptFilterModel.PatientId = this.selectedPatientId;
      this.reportCreditCardReceiptFilterModel.LedgerId = this.selectedLedgerId;
      this.newItemEvent.emit(this.reportCreditCardReceiptFilterModel);
    }
    // Recall Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_RecallReport) {
      this.reportRecallFilterModel = new ReportRecallParamsModel();

      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportRecallFilterModel.isProvider = true;
        this.reportRecallFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportRecallFilterModel.isPractice = true;
        this.reportRecallFilterModel.PracticeId = this.selectedClient.TDOCID;
        this.reportRecallFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportRecallFilterModel.initialDate = this.startDate;
      this.reportRecallFilterModel.endDate = this.endDate;
      this.newItemEvent.emit(this.reportRecallFilterModel);
    }
    // Procedures with no claims
     else if (this.showParametersForReport === ReportIDEnum.reportID_ProceduresWithNoClaims) {
      this.reportProceduresWithNoClaimsModel = new ReportFinancialSnapshotFilterModel();

      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportProceduresWithNoClaimsModel.isProvider = true;
        this.reportProceduresWithNoClaimsModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportProceduresWithNoClaimsModel.isPractice = true;
        this.reportProceduresWithNoClaimsModel.PracticeId = this.selectedClient.TDOCID;
        this.reportProceduresWithNoClaimsModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportProceduresWithNoClaimsModel.initialDate = this.startDate;
      this.reportProceduresWithNoClaimsModel.endDate = this.endDate;
      this.newItemEvent.emit(this.reportProceduresWithNoClaimsModel);
    }
    //Claims not sent
    else if (this.showParametersForReport === ReportIDEnum.reportID_ClaimsNoSent) {
      this.reportClaimsNotSentModel = new ReportFinancialSnapshotFilterModel();

      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportClaimsNotSentModel.isProvider = true;
        this.reportClaimsNotSentModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportClaimsNotSentModel.isPractice = true;
        this.reportClaimsNotSentModel.PracticeId = this.selectedClient.TDOCID;
        this.reportClaimsNotSentModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }
      this.reportClaimsNotSentModel.initialDate = this.startDate;
      this.reportClaimsNotSentModel.endDate = this.endDate;
      this.newItemEvent.emit(this.reportClaimsNotSentModel);
    }
     //Outstanding Claims
    else if (this.showParametersForReport === ReportIDEnum.reportID_OutstandingClaims) 
     {
      this.reportOutstandingClaimsModel = new ReportOutstandigClaimsModel();
      // check filter for provider or practice
      if (this.isReportForProvide) {
        if (this.selectedProviders.length === 0) {
          return;
        }
        this.reportOutstandingClaimsModel.isProvider = true;
        this.reportOutstandingClaimsModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      }
      if (this.isReportForPractice) {
        if (this.selectedClient === undefined) {
          return;
        }
        if (this.selectedClientLocation.length === 0) {
          return;
        }
        this.reportOutstandingClaimsModel.isPractice = true;
        this.reportOutstandingClaimsModel.PracticeId = this.selectedClient.TDOCID;
        this.reportOutstandingClaimsModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      }

      this.reportOutstandingClaimsModel.isEClaims = this.isEClaims;
      this.reportOutstandingClaimsModel.isADAForm = this.isADAForm;
      
      this.reportOutstandingClaimsModel.Over30 = this.over30;
      this.reportOutstandingClaimsModel.Over60 = this.over60;
      this.reportOutstandingClaimsModel.Over90 = this.over90;
      this.newItemEvent.emit(this.reportOutstandingClaimsModel);
    }
    //Bank Deposit
    else if (this.showParametersForReport === ReportIDEnum.reportID_BankDeposits) {
      this.reportBankDepositsModel = new ReportBankDepositsParamsModel();
      this.reportBankDepositsModel.isCash = this.isCash;
      this.reportBankDepositsModel.isCheck = this.isCheck;
      this.reportBankDepositsModel.isCashandCheck = this.isCashandCheck;
      this.newItemEvent.emit(this.reportBankDepositsModel);
    }
    //Fee Calculation Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_FeeCalculationReport) {
      this.reportFeeCalculationReportModel = new ReportFeeCalculationReportParamsModel();
      this.reportFeeCalculationReportModel.isOrderedByDate = this.isOrderedByDate;
      this.reportFeeCalculationReportModel.isOrderedByToothCode = this.isOrderedByToothCode;
      this.newItemEvent.emit(this.reportFeeCalculationReportModel);
    }

    //Referring Analysis Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_ReferringAnalysis) {
      this.reportReferringAnalysisModel = new ReportReferringAnalysisModel();
      this.reportReferringAnalysisModel.isProvider = this.isReportForProvide;
      this.reportReferringAnalysisModel.isPractice = this.isReportForPractice;
      this.reportReferringAnalysisModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      this.reportReferringAnalysisModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      this.reportReferringAnalysisModel.initialDate = this.startDate;
      this.reportReferringAnalysisModel.endDate = this.endDate;
      this.reportReferringAnalysisModel.isAll = this.isAll;
      this.reportReferringAnalysisModel.IncludePerDoctor = this.IncludePerDoctor;
      this.reportReferringAnalysisModel.IncludePerCode = this.IncludePerCode;
      this.reportReferringAnalysisModel.IncludeBreakDown = this.IncludeBreakDown;
      this.newItemEvent.emit(this.reportReferringAnalysisModel);
    }
    //Patients Need Appointment Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_PatientsNeedAppointment) {
      this.reportPatientsNeedAppointmentModel = new ReportPatientsNeedAppointmentParamsModel();
      this.reportPatientsNeedAppointmentModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      this.reportPatientsNeedAppointmentModel.initialDate = this.startDate;
      this.reportPatientsNeedAppointmentModel.endDate = this.endDate;
      this.reportPatientsNeedAppointmentModel.isNewOnly = this.isNewOnly;
      this.newItemEvent.emit(this.reportPatientsNeedAppointmentModel);
    }
    //Recall Appointment Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_Recall_Appointment) {
      this.reportRecallAppointmentModel = new ReportRecallAppointmentParamsModel();
      this.reportRecallAppointmentModel.isProvider = this.isReportForProvide;
      this.reportRecallAppointmentModel.isPractice = this.isReportForPractice;
      this.reportRecallAppointmentModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      this.reportRecallAppointmentModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      this.reportRecallAppointmentModel.initialDate = this.startDate;
      this.reportRecallAppointmentModel.endDate = this.endDate;
      this.reportRecallAppointmentModel.isFollowUp = this.isFollowUp;
      this.reportRecallAppointmentModel.isAllProviders = this.isAllProviders;
      this.reportRecallAppointmentModel.isAllLocations = this.isAllLocations;
    }
    //Call List Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_Call_List) {
      this.reportCallListModel = new ReportCallListParamsModel();
      this.reportCallListModel.isProvider = this.isReportForProvide;
      this.reportCallListModel.isPractice = this.isReportForPractice;
      this.reportCallListModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      this.reportCallListModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      this.reportCallListModel.isAllProviders = this.isAllProviders;
      this.reportCallListModel.isAllLocations = this.isAllLocations;
      this.reportCallListModel.initialDate = this.startDate;
    }
    //Collection Report
    else if (this.showParametersForReport === ReportIDEnum.reportID_Collection_Report) {
      this.reportCollectionFilterModel = new ReportCollectionParamsModel();
      this.reportCollectionFilterModel.isProvider = this.isReportForProvide;
      this.reportCollectionFilterModel.isAllProviders = this.isAllProviders;
      this.reportCollectionFilterModel.isAllLocations = this.isAllLocations;
      this.reportCollectionFilterModel.isPractice = this.isReportForPractice;
      this.reportCollectionFilterModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      this.reportCollectionFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      this.newItemEvent.emit(this.reportCollectionFilterModel);
    }
    //Unapplied Credits
    else if (this.showParametersForReport === ReportIDEnum.reportID_Unapplied_Credits) {
      this.reportUnappliedCreditsModel = new ReportUnappliedCreditsParamsModel();
      this.reportUnappliedCreditsModel.isProvider = this.isReportForProvide;
      this.reportUnappliedCreditsModel.isAllProviders = this.isAllProviders;
      this.reportUnappliedCreditsModel.isAllLocations = this.isAllLocations;
      this.reportUnappliedCreditsModel.isPractice = this.isReportForPractice;
      this.reportUnappliedCreditsModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
      this.reportUnappliedCreditsModel.PracticeLocations = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString());
      this.newItemEvent.emit(this.reportUnappliedCreditsModel);
    }
    //Deleted Anesthesia
    else if (this.showParametersForReport === ReportIDEnum.reportID_Deleted_Anesthesia) {
      this.reportDeletedAnesthesiaModel = new ReportDeletedAnesthesiaParamsModel();
      this.reportDeletedAnesthesiaModel.initialDate = this.startDate;
      this.reportDeletedAnesthesiaModel.endDate = this.endDate;
      this.newItemEvent.emit(this.reportDeletedAnesthesiaModel);
    }
    //Patient Case Referrals  
    else if (this.showParametersForReport === ReportIDEnum.reportID_Patient_Case_Referrals) {
      this.reportPatientCaseReferralsModel = new ReportPatientCaseReferralsParamsModel();
      this.reportPatientCaseReferralsModel.initialDate = this.startDate;
      this.reportPatientCaseReferralsModel.endDate = this.endDate;
      this.newItemEvent.emit(this.reportPatientCaseReferralsModel);
    }
    //Reports to be completed
    else if (this.showParametersForReport === ReportIDEnum.reportID_Reports_to_be_completed) {
      this.reportReportsToBeCompletedModel = new ReportReportsToBeCompletedParamsModel();
      this.reportReportsToBeCompletedModel.isProvider = this.isReportForProvide;
      this.reportReportsToBeCompletedModel.isPractice = this.isReportForPractice;

      this.reportReportsToBeCompletedModel.LocationsIdList = this.selectedClientLocation.filter(o => o.LOCID !== undefined).map(x => x.LOCID.toString()).join(',');
      this.reportReportsToBeCompletedModel.ProvidersIdList = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId).join(',');
      this.newItemEvent.emit(this.reportReportsToBeCompletedModel);
    }
    
  }

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }

  updateAllLedgerReportsComplete() {
    this.allLedgerReports = this.reports.subtasks != null && this.reports.subtasks.every(t => t.completed);
  }


  updateAllLedgerTransactionReports() {
    this.allLedgerTransactionReports = this.reports.subtasks.filter(x => x.name === 'Transactions (type)') != null &&
      this.reports.subtasks.find(x => x.name === 'Transactions (type)').subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allLedgerReports;
  }

  someReportsComplete(): boolean {
    if (this.reports.subtasks == null) {
      return false;
    }
    return this.reports.subtasks.filter(t => t.completed).length > 0 && !this.allLedgerReports;
  }

  someLedgerTransactionsReportsComplete(): boolean {
    if (this.reports.subtasks.filter(x => x.name === 'Transactions (type)') === null) {
      return false;
    }
    return this.reports.subtasks.filter(x => x.name === 'Transactions (type)').filter(t => t.completed).length > 0 &&
      !this.allLedgerTransactionReports;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => (t.completed = completed));
  }

  setAllLedgerReports(completed: boolean) {
    this.allLedgerReports = completed;
    if (this.reports.subtasks == null) {
      return;
    }
    this.reports.subtasks.forEach(t => (t.completed = completed));
  }

  setAllLedgerTransactionReports(completed: boolean) {
    this.allLedgerTransactionReports = completed;
    if (this.reports.subtasks.filter(x => x.name === 'Transactions (type)') === null) {
      return;
    }
    this.reports.subtasks.find(x => x.name === 'Transactions (type)').subtasks.forEach(t => (t.completed = completed));
  }

  updateReportFormatted(isChecked: boolean) {
    this.isReportFormatted = isChecked;
  }

  updateFilterByProvider(isChecked: boolean) {
    this.isReportForProvide = isChecked;
  }
  updateFilterByAllClaims(eventChange: MatRadioChange): void {
    switch (eventChange.value) {
      case 'All':
      this.isEClaims = false;
      this.isADAForm = false;
      break;
      case 'eClaims':
      this.isEClaims = true;
      this.isADAForm = false;
      break;
      case 'ADA':
      this.isADAForm = true;
      this.isEClaims = false;
      break;
      default:
      console.warn('Unexpected value:', eventChange.value);
    }
   }

   updateFilterByBankDeposit(eventChange: MatRadioChange): void {
    switch (eventChange.value) {
      case 'Cash':
      this.isCash = true;
      this.isCheck = false;
      this.isCashandCheck = false;
      break;
      case 'Check':
      this.isCheck = true;
      this.isCash = false;
      this.isCashandCheck = false;
      break;
      case 'All':
      this.isCashandCheck = true;
      this.isCash = false;
      this.isCheck = false;
      break;
      default:
      console.warn('Unexpected value:', eventChange.value);
    }
    
   }

   updateFilterByRecallAppointment(eventChange: MatRadioChange): void {
    switch (eventChange.value) {
      case 'followUp':
        this.isFollowUp = true;
        break;
      case 'request':
        this.isFollowUp = false;
        break;
      default:
      console.warn('Unexpected value:', eventChange.value);
    }
   }

   updateFilterByFeeCalculationReport(eventChange: MatRadioChange): void {
    switch (eventChange.value) {
      case 'Date':
        this.isOrderedByDate = true;
        this.isOrderedByToothCode = false;
      break;
      case 'ToothCode':
        this.isOrderedByDate = false;
        this.isOrderedByToothCode = true;
      break;
      default:
      console.warn('Unexpected value:', eventChange.value);
    }
   }
   
   updateFilterByOverTIme(eventChange: MatRadioChange): void {
    switch (eventChange.value) {
      case 'All':
        this.over30 = false;
        this.over60 = false;
        this.over90 = false;
      break;
      case '30':
        this.over30 = true;
        this.over60 = false;
        this.over90 = false;
      break;
      case '60':
        this.over30 = false;
        this.over60 = true;
        this.over90 = false;
      break;
      case '90':
        this.over30 = false;
        this.over60 = false;
        this.over90 = true;
        break;
    }
  }

  updateFilterByOpen(eventChange: MatRadioChange): void {
    switch (eventChange.value) {
      case '10':
        this.isAll = false  ;
      break;
      case 'All':
        this.isAll = true;
      break;
    }
  }
  updateFilterByPractice(isChecked: boolean) {
    this.isReportForPractice = isChecked;
  }


  onDoctorSelect(event: any) {
    if (event.isUserInput) {
      this.doctorSelected = event.value;
    }

  }

  onChangeClient(event) {
    this.selectedClient = event.value;
    this.selectedClientLocation = [];
    this.doctorService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
    });
  }

  onChangeClientLocation(event) {
    if (event.isUserInput) {
      this.selectedClientLocation = event.value as ClientLocationDataModel[];
    }
    this.isAllLocations = this.locationList && this.selectedClientLocation.filter(o => o.LOCID !== undefined).length === this.locationList.length;
  }

  onDoctorsSelected(event) {
    if (event.isUserInput) {
      this.selectedProviders = event.value as DoctorDataModel[];
    }
    this.isAllProviders = this.selectedProviders.filter(o => o.DoctorId !== undefined).length === this.staticDataService.currentLocationDoctors.length;
  }

  toggleInteractiveReport(event: MatCheckboxChange){
    this.isInteractiveReport = event.source.checked;
    this.onChecked.emit(event.source.checked);
  }

  toggleNewPatientsOnly(event: MatCheckboxChange){
    this.isNewOnly = event.source.checked;
  }

  onChangeProvider(event) {
    this.isBusy = true;
    this.selectedProvider = event.value;
  }

  radioChange(event: MatRadioChange) {
    event.value === 'true' ? this.isAsc = true : this.isAsc = false;
  }

  radioTransactionChange(event: MatRadioChange) {
    switch (event.value) {
      case this.enumTransactionTypeCheck:
        this.transactionType = this.enumTransactionTypeCheck.toString();
        break;
      case this.enumTransactionTypeCreditCard:
        this.transactionType = this.enumTransactionTypeCreditCard.toString();
        break;
      case this.enumTransactionTypeDebit:
        this.transactionType = this.enumTransactionTypeDebit.toString();
        break;
      case this.enumTransactionTypeOther:
        this.transactionType = this.enumTransactionTypeOther.toString();
        break;
    }
  }

  radioVoidedTransactionChange(event: MatRadioChange) {
    event.value === 'true' ? this.isOrderByDateCharged = true : this.isOrderByDateCharged = false;
  }


  toggle(event: MatCheckboxChange) {
    this.isTrueBalance = event.source.checked;
  }

  attributeDisplay(attribute1, attribute2) {
    if (attribute1.id === attribute2.id) {
      return attribute1.name;
    } else {
      return '';
    }
  }

  loadServiceData() {
    this.locService.getClients().subscribe(data => {
      this.clientList = data;
      if (this.clientList.length > 0) {
        // Try to locate current users client
        this.selectedClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
        // getting location for current practice
        this.doctorService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
          this.locationList = ldata;
          if (this.locationList.length > 0) {
            this.selectedClientLocation.push(this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID));
          }
        });
      }
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
    this.transactionType = this.enumTransactionTypeCheck.toString();
    this.selectedProvidersList = this.staticDataService.currentLocationDoctors;
    this.filterDateRangesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumIOFilterDateRanges');
    // set default parameters
    this.selectedDateRanges = this.filterDateRangesEnums.find(p => p.ValidValueItemId.toString() === DataRangesEnum.Today);
    this.setDatesRanges();

  }

  /*checkList() {
    console.log('Providers:' + JSON.stringify(this.selectedProviders));
    console.log('Client:' + JSON.stringify(this.selectedClient));
    console.log('Locations:' + JSON.stringify(this.selectedClientLocation));
  }*/

  setDatesRanges() {
    // this.isDateRangeDefined = true;
    const {startDate, endDate, isCurrentMonth} = Utils.getDataRange(this.selectedDateRanges.ValidValueItemId);
    // console.log('startDate:'  + startDate + ' endDate: ' + endDate + ' iscurrent:' + isCurrentMonth);
    this.startDate = startDate;
    this.endDate = endDate;
    this.isCurrentMonth = isCurrentMonth;
  }

  onChangeDateRanges(event) {
    this.selectedDateRanges = event.value;
    this.setDatesRanges();
  }

  UserDefined() {
    // set User Defined parameters
    this.selectedDateRanges = this.filterDateRangesEnums.find(p => p.ValidValueItemId.toString() === DataRangesEnum.UserDefined);
  }
  GetCCPaymentList(){
    let initDate =  this.datePipe.transform(ConversionUtilities.getInitialDate(this.startDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
    let endDate =  this.datePipe.transform(ConversionUtilities.getEndDate(this.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
    let currentPatient = Constants.emptyGuid
    if(this.isCurrentPatient){
      currentPatient = this.globals.currentPatientId;
    }

    this.arservice.getCCPayments(currentPatient, initDate, endDate).subscribe(data => {
      this.PaymentList = data;
    });

  }

  onRowSelected($event: TdoTableSelectionEvent){ 
    this.selectedPaymentId = $event.model.PaymentID;
    this.selectedPatientId = $event.model.PatientID;
    this.selectedLedgerId = $event.model.LedgerID;
  }

  PatientSelectedChange(event: MatRadioChange) {
    this.isCurrentPatient = event.value === 'true';
   }

  onChangeOrderByOption(event) {
    this.selectedOrderByOption = event.value;
  }

  onChangeOrderByOptionDaily(event){
    this.selectedSnapShotOrderBy = event.value;
  }

  showInactiveDoc(event: MatCheckboxChange){
    this.showInactive = event.source.checked;

  }


}
